/**
 * This file creates the interface definitions for the Jarvis Service Doc Provider Plugin.
 * The Doc Provider Plugin allows "managed" document sets created by Doc Provider Jarvis
 * Services to be created, retrieved and used by Jarvis WebView-based web apps.  "Managed"
 * in this context means managed by a singleton DocSetManager.  This plugin also
 * allows web apps to add specific document types to managed document sets.
 *
 * This specification only intends to define the Typescript interface that a web app uses,
 * and does not define any native/platform-specific APIs.
 *
 * @packageDocumentation
 * @module DocProviderPlugin
 */
/**
 * Enumerates different types of errors
 */
export var DocProviderErrorType;
(function (DocProviderErrorType) {
    /**
     * A Doc with the specified id was not found
     */
    DocProviderErrorType["docNotFound"] = "docNotFound";
    /**
     * A DocSet with the specified id was not found
     */
    DocProviderErrorType["docSetNotFound"] = "docSetNotFound";
})(DocProviderErrorType || (DocProviderErrorType = {}));
//# sourceMappingURL=docprovider.js.map